
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/linkedin",
      function () {
        return require("private-next-pages/destinations/linkedin.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/linkedin"])
      });
    }
  